<template>
  <div>
    <WsText001 h6> 31-1. car with blue border top </WsText001>
    <LlAuditCard
      :btn-text="$t('建立稽核行程')"
      btn-icon="icon-nav-add-audit"
      :title="'title'"
      :tags="LlAuditCard.tags"
      :spec="LlAuditCard.spec"
      :is-ellipsis2="false"
      :chips="LlAuditCard.chips"
      :hasTopBar="true"
    />
    <WsText001 h6 class="mt-8">
      31-2. car without blue border top
    </WsText001>
    <LlAuditCard
      :btn-text="$t('建立稽核行程')"
      btn-icon="icon-nav-add-audit"
      :title="'title'"
      :tags="LlAuditCard.tags"
      :spec="LlAuditCard.spec"
      :is-ellipsis2="false"
      :chips="LlAuditCard.chips"
      :hasTopBar="false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      LlAuditCard: {
        tag: [
          {
            text: "tag",
            image:
              "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
          },
          {
            text: "tag",
            image:
              "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970291166yRtf/%E6%B0%B4%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=7528b177496042d3318344d1aa5e5f0718a4001d945a0c2a8a35de2e8258e0b9",
          },
          {
            text: "tag",
            image:
              "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029106MXgKP/%E5%9B%BA%E9%AB%94%E5%BB%A2%E7%89%A9%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=ad3a10bc3f516d753ff2afc5ae063aee3d60ac6fe1ee0d6cb47cfbb4396e0c54",
          },
        ],
        spec: [{ title: "spec-title", text: "spec-text" }],
        chips: [{ color: "yellow", text: "chips" }],
      },
    }
  }
}
</script>

<style>

</style>